import { render } from "./stat_sales.vue?vue&type=template&id=6b7fff5e"
const script = {}

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__